import React, { useEffect } from "react";
import { Routes, Route, Link } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Profile from "./page/Profile";
import Home from "./page/Home";
import About from "./page/About";
import SingleCocktail from "./page/SingleCocktail";
import Cart from "./page/Cart";
import Signin from "./page/signup-signin/Signin";
import Signup from "./page/signup-signin/Signup";
import Footer from "./components/Footer/Footer";
import Error from "./page/Error";
import { MyGlobalContext } from "./Context";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsFillCartCheckFill } from "react-icons/bs";
import { AiFillCloseSquare } from "react-icons/ai";

function App() {
  const {
    token,
    totalItem,
    isCartAddBtnClicked,
    setIsCartAddBtnClicked,
    path,
    toggleRunPath,
  } = MyGlobalContext();

  useEffect(() => {
    if (path === "/" && isCartAddBtnClicked) {
      setIsCartAddBtnClicked(true);
    } else {
      setIsCartAddBtnClicked(false);
    }
  }, [path]);
  // console.log(path);
  // useEffect(() => {
  //   const auto = setTimeout(() => {
  //     toast.warn(
  //       "This site still in development mode! Soon the owner of this site will update the site and will add some important features(such as login system, payment method, modify the UI",
  //       {
  //         position: "top-center",
  //         autoClose: 10000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "colored",
  //       }
  //     );
  //   }, 500);
  //   return () => {
  //     clearTimeout(auto);
  //   };
  // }, []);
  return (
    <div className="App relative">
      {isCartAddBtnClicked && (
        <div className="btn-cart-clicked-product-pos-ab w-full flex justify-end text-[27px] pr-0">
          <div className="relative bg-[rgba(64,0,255,0.5)] pl-3 py-2 btn-cart-sticky">
            <Link
              onClick={() => {
                setIsCartAddBtnClicked(false);
                toggleRunPath();
              }}
              to="/cart"
              className="text-[#ffffff]"
            >
              <BsFillCartCheckFill />
              <p className="absolute top-0 left-1 bg-[red] text-[12px] flex justify-center items-center w-4 rounded-full">
                {totalItem}
              </p>
            </Link>
            <button
              onClick={() => setIsCartAddBtnClicked(false)}
              className=" absolute bottom-[-1px] left-[4px] text-[20px] text-[#ffdd00]"
            >
              <AiFillCloseSquare />
            </button>
          </div>
        </div>
      )}

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Home />
              <Footer />
            </>
          }
        />
        {token.length !== 0 ? (
          <Route
            path="/profile"
            element={
              <>
                <Navbar />
                <Profile />
              </>
            }
          />
        ) : (
          <Route
            path="/login"
            element={
              <>
                <Navbar />
                <Signin />
              </>
            }
          />
        )}
        <Route
          path="/about"
          element={
            <>
              <Navbar />
              <About />
              <Footer />
            </>
          }
        />
        <Route
          path="/singlecocktail/:id"
          element={
            <>
              <Navbar />
              <SingleCocktail />
            </>
          }
        />
        <Route
          path="/cart"
          element={
            <>
              <Navbar />
              <Cart />
            </>
          }
        />
        <Route
          path="/register"
          element={
            <>
              <Navbar />
              <Signup />
            </>
          }
        />
        <Route path="*" element={<Error />} />
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;
